import { TextField } from '@material-ui/core'
import { StandardTextFieldProps } from '@material-ui/core/TextField'
import { FieldProps } from 'formik'
import React from 'react'

import { formatDateInput } from '../helpers/formats'

interface IProps extends FieldProps, StandardTextFieldProps {}

export const FormDateField: React.FC<IProps> = ({ field, form, ...props }) => {
  const isValid = !(form.touched[field.name] && form.errors[field.name])
  return (
    <TextField
      fullWidth
      id={field.name}
      name={field.name}
      error={!isValid}
      type="date"
      value={field.value ? formatDateInput(field.value) : ''}
      onChange={ev => {
        const { value } = ev.target
        if (value) {
          form.setFieldValue(field.name, new Date(value).toISOString())
        } else {
          form.setFieldValue(field.name, '')
        }
      }}
      InputLabelProps={{
        shrink: true,
      }}
      {...props}
    />
  )
}
